import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import useTranslation from '~/i18n/i18n';
import { useSupabase } from '../providers/supabase-provider';

export const useLogout = () => {
  const { t } = useTranslation();

  const supabase = useSupabase();

  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: async () => {
      return await supabase.auth.signOut();
    },
    onSuccess: () => {
      // Clear all network cache so that all the data is refetched.
      queryClient.clear();
    },
    onError: (error) => {
      toast.error(t('auth.errors.signOutError'));
      console.error(t('auth.errors.signOutError'), error);
    },
  });

  return { logout: mutate, isLoading };
};
